import React from 'react'
// import {
//     Route
// } from "react-router-dom";
import NavBar from '../components/NavBar'
import Footer from '../components/Footer';
// import ErrorPage from './ErrorPage'
import Dashboard from './DashboardPage'
import LeaveRequest from './LeaveRequest'
import Calendar from './CalendarPage'
import ApproveIndex from './ApproveList/Index'
import Settings from './Settings'

import LeaveIndex from './LeaveList/Index'
import Salaries from './Salarys/Salaries'
import CheckIn from './CheckIn/Index'


import PrivateRoute from "../guard/auth";

function Page() {

    return (
        <>
            <NavBar />
            <section className="home">
                <PrivateRoute path="/dashboard">
                    <Dashboard />
                </PrivateRoute>
                <PrivateRoute path="/calendar">
                    <Calendar />
                </PrivateRoute>
                <PrivateRoute path="/request">
                    <LeaveRequest />
                </PrivateRoute>
                <PrivateRoute path="/approve">
                    <ApproveIndex />
                </PrivateRoute>
                <PrivateRoute path="/leave">
                    <LeaveIndex />
                </PrivateRoute>
                <PrivateRoute path="/salary">
                    <Salaries />
                </PrivateRoute>
                <PrivateRoute path="/check-in">
                    <CheckIn />
                </PrivateRoute>
                <PrivateRoute path="/settings">
                    <Settings />
                </PrivateRoute>
                

              
                {/* <Route path="*">
                    <ErrorPage />
                </Route> */}
                {/* <Route
                    path="/ApproveList"
                    render={({ match: { url } }) => (
                        <>
                            <Route path={`${url}/`} exact>
                                <ApproveIndex />
                            </Route>
                            <Route path={`${url}/:id`} >
                                <ApproveView />
                            </Route>
                        </>
                    )}

                >
                </Route>
                <Route
                    path="/LeaveList"
                    render={({ match: { url } }) => (
                        <>
                            <PrivateRoute path={`${url}/`} exact>
                                <LeaveIndex />
                            </PrivateRoute>
                        </>
                    )}
                >
                </Route> */}




            </section>
            <Footer />
        </>
    )
}

export default Page
